import { render } from "./HomeEntry.vue?vue&type=template&id=774d35dc"
import script from "./HomeEntry.vue?vue&type=script&lang=js"
export * from "./HomeEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__